import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { getActiveResumeUserJobId } from "@/store/resume/selectors";

export const getUserJobState = (state: RootState) => state.userJob;

export const getUserJobs = createSelector(
    getUserJobState,
    userJobs => userJobs.userJobs,
);

export const getActiveUserJob = createSelector(
    getUserJobState,
    userJobs => userJobs.activeUserJob,
);

export const getActiveResumeUserJobDetails = createSelector(
    getActiveResumeUserJobId,
    getUserJobs,
    (activeUserJobId, userJobs) => {
        return userJobs.find(userJob => userJob.id === activeUserJobId);
    },
);

export const getUserJobById = createSelector(
    getUserJobs,
    (_: RootState, userJobId: string) => userJobId,
    (userJobs, userJobId) => userJobs.find(userJob => userJob.id === userJobId),
);

export const getNonArchivedUserJobs = createSelector(getUserJobs, userJobs =>
    userJobs.filter(userJob => !userJob.archivedAt),
);

export const getArchivedUserJobs = createSelector(getUserJobs, userJobs =>
    userJobs.filter(userJob => {
        const archivedAt = userJob.archivedAt;
        return typeof archivedAt === "string"
            ? new Date(archivedAt)
            : archivedAt;
    }),
);
